import type { ImageGalleryColorDialogFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { Image } from '@packages/shared/src/ui/Image/Image';
import type { FC } from 'react';

type Value = ImageGalleryColorDialogFragmentFragment['dimensions'][number]['values'][number];

export interface ImageGalleryColorDialogItemProps {
  /**
   * The dimension value to display.
   */
  value: Value;

  /**
   * Select handler. Call when the variation has been selected (clicked)
   *
   * @param value Dimension value.
   */
  onSelect(value: Value): void;
}

export const ImageGalleryColorDialogItem: FC<ImageGalleryColorDialogItemProps> = ({
  value,
  onSelect,
}) => (
  <div
    role="button"
    tabIndex={0}
    onClick={() => onSelect(value)}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        onSelect(value);
      }
    }}
    // m-[2px] -> the horziontal scroll component will cut off the box shadow otherwise, caused by overflow-hidden
    className={`border-color-text-dark m-[2px] w-[96px] min-w-[96px] overflow-hidden rounded ${value.isSelected ? 'border-2' : 'border-none'} shadow-color-grey-dark flex flex-col justify-stretch border-solid shadow-sm`}
  >
    <div className="relative h-[96px] w-[96px]">
      {value.variationMainImage ? (
        /* TODO: where do we get an alt text from? */
        <Image fill src={`${value.variationMainImage}?$PDV_gallery$`} alt="" />
      ) : (
        value.rgb && (
          <div
            title={value.displayText || ''}
            className="h-full w-full"
            style={{ backgroundColor: `#${value.rgb}` }}
          />
        )
      )}
    </div>
    <p className="text-size-body3 hyphens-auto px-1 py-1.5 text-center">{value.displayText}</p>
  </div>
);
